import { Avatar, AvatarFallback } from '@/components/ui/avatar'
import { Button } from '@/components/ui/button'
import { avatarLabel } from '@/utils'
import type { Organization } from '@stytch/vanilla-js'
import { MapPin, Trash2, Users } from 'lucide-react'
import { Link, useNavigate } from 'react-router-dom'

import type { FC } from 'react'

interface WorkspaceSummaryCardProps {
	workspace?: Organization
	onWorkspaceSelect?: (workspace?: Organization) => void
	onDelete: () => void
}

export const WorkspaceSummaryCard: FC<WorkspaceSummaryCardProps> = ({
	workspace,
	onWorkspaceSelect,
	onDelete,
}) => {
	const navigate = useNavigate()

	return (
		<Link
			to={`/${workspace?.organization_slug}/grids`}
			onClick={() => onWorkspaceSelect?.()}
			className="flex items-center gap-4 p-4 cursor-pointer hover:border-primary border-1 border-transparent rounded-lg group relative focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-light"
		>
			<Avatar className="h-14 w-14 rounded-lg">
				{/* <AvatarImage src={workspace.background_image || undefined} /> TODO: Do again after getting rid of old workspaces */}
				<AvatarFallback className="rounded-lg text-lg">
					{avatarLabel(workspace?.organization_name)}
				</AvatarFallback>
			</Avatar>

			<div className="flex-1">
				<h3 className="font-medium">{workspace?.organization_name}</h3>
			</div>

			<div className="flex items-center gap-2" onClick={(e) => e.stopPropagation()}>
				<Button
					variant="ghost"
					size="icon"
					className="cursor-pointer"
					onClick={(e) => {
						e.preventDefault()
						navigate(`/${workspace?.organization_slug}/settings/users`)
					}}
				>
					<Users className="h-4 w-4" />
				</Button>
				<Button
					variant="ghost"
					size="icon"
					className="cursor-pointer"
					onClick={(e) => {
						e.preventDefault()
						navigate(`/${workspace?.organization_slug}/locations`)
					}}
				>
					<MapPin className="h-4 w-4" />
				</Button>
				<Button
					variant="ghost"
					size="icon"
					className="cursor-pointer"
					onClick={(e) => {
						e.preventDefault()
						e.stopPropagation()
						onDelete()
					}}
				>
					<Trash2 className="h-4 w-4" />
				</Button>
			</div>
		</Link>
	)
}
